import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
export const FileStatusButton = (param)=>{
    let { onClick, label, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: label,
        sideOffset: 4,
        side: "top",
        children: /*#__PURE__*/ _jsx(IconButton, {
            appearance: "ghost",
            color: "grey",
            onClick: onClick,
            size: "small",
            label: label,
            ...restOfProps
        })
    });
};
